<section class="banner">
  <div class="banner__copy">
    <span class="banner__eyebrow">{{ 'banner.eyebrow' | translate }}</span>
    <h2 class="banner__headline">{{ 'banner.title' | translate }}</h2>
    <p class="banner__subtitle">{{ 'banner.subtitle' | translate }}</p>
  </div>

  <button type="button" class="banner__action">{{ 'banner.action' | translate }}</button>
</section>
